import { Spacing } from '@persona-id/design-tokens';
import { last } from 'lodash';
import { components, OptionProps } from 'react-select';
import styled from 'styled-components';

import CaseStatusSticker from 'dashboard/components/CaseStatusSticker';
import { OptionType } from 'dashboard/components/ReactSelect';
import { CaseStateColor } from 'dashboard/models/case-template';

const OptionContainer = styled('div')`
  display: flex;
  align-items: center;
  column-gap: ${Spacing[2]};
`;

const CaseStatusColorOption = (props: OptionProps<OptionType<CaseStateColor>>) => {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const index = last(props.innerProps.id.split('-'));
  const id = props.selectProps.id != null ? `${props.selectProps.id}_${index}` : undefined;

  return (
    <components.Option {...props} innerProps={{ ...props.innerProps, id }}>
      <OptionContainer>
        <CaseStatusSticker caseState={{ name: 'Status', color: props.data.value }} />
        <span>{props.data.label}</span>
      </OptionContainer>
    </components.Option>
  );
};

export default CaseStatusColorOption;
